/**
 * The Alpha–Omega mark.
 *
 * Α and Ω are the first and the last: where public money starts and who
 * finally receives it. Between them sits a single node on a connecting line —
 * the intermediary, which is the whole subject of this tool. That line is
 * drawn in the same weight as a graph edge elsewhere in the app, so the mark
 * is a small statement of what the pages contain rather than an ornament.
 *
 * Monochrome by default, inheriting currentColor: the house rule reserves
 * saturated colour for things that carry data meaning, and a logo does not.
 */

export function Logo({ size = 34, title = 'Алфа-Омега' }: {
  size?: number; title?: string;
}) {
  return (
    <svg
      className="mark"
      width={size * (48 / 32)}
      height={size}
      viewBox="0 0 48 32"
      role="img"
      aria-label={title}
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Α — the source */}
      <path d="M3 26 L9.5 6 L16 26" />
      <path d="M6.2 19.5 L12.8 19.5" />

      {/* the chain between them, and the intermediary on it */}
      <path d="M18.6 16 H29.4" strokeWidth={1.4} opacity={0.75} />
      <circle cx="24" cy="16" r="2.3" fill="currentColor" stroke="none" />

      {/* Ω — the recipient */}
      <path d="M32 26 L35.5 26 C30 22 31.5 8 39 8 C46.5 8 48 22 42.5 26 L46 26" />
    </svg>
  );
}
